import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c3dfed9"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = ["data-bs-target", "aria-expanded", "aria-controls"];
const _hoisted_4 = ["id", "aria-labelledby", "data-bs-parent"];
const _hoisted_5 = { class: "accordion-body p-2 pt-0 pb-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "accordion-item",
        id: _ctx.id
    }, [
        _createElementVNode("h2", {
            class: "accordion-header",
            id: 'heading-' + _ctx.id
        }, [
            _createElementVNode("button", {
                class: _normalizeClass('accordion-button bg-primary text-white p-2' + (_ctx.show ? '' : ' collapsed')),
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": '#collapse-' + _ctx.id,
                "aria-expanded": _ctx.show,
                "aria-controls": 'collapse-' + _ctx.id
            }, _toDisplayString(_ctx.title), 11, _hoisted_3)
        ], 8, _hoisted_2),
        _createElementVNode("div", {
            id: 'collapse-' + _ctx.id,
            class: _normalizeClass('accordion-collapse collapse' + (_ctx.show ? ' show' : '')),
            "aria-labelledby": 'heading-' + _ctx.id,
            "data-bs-parent": '#' + _ctx.id
        }, [
            _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
        ], 10, _hoisted_4)
    ], 8, _hoisted_1));
}
